import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';
import {
  Fund,
  Strategy,
  ProductType,
  PaginationMeta,
  OrganisationManager,
  FundFilters,
  FundRow,
  Currency
} from '../types';
import { IFundState } from './state';
import { PensionScheme } from '@/modules/pensionScheme/types';
import { SubFund } from '@/modules/subFund/types';

/**
 * --------------------------------------------------
 *	Organisation Getters
 * --------------------------------------------------
 **/
export const FundGetters: IFundGetters = {
  organizationFunds: (state: IFundState): Fund[] => state.organizationFunds,
  selectedFund: (state: IFundState): FundRow => state.selectedFund,
  organizationExposedFunds: (state: IFundState): Fund[] =>
    state.organizationExposedFunds,
  organizationPensionSchemes: (state: IFundState): PensionScheme[] =>
    state.pensionSchemes,
  strategies: (state: IFundState): Strategy[] => state.strategies,
  productTypes: (state: IFundState): ProductType[] => state.productTypes,
  paginationMeta: (state: IFundState): PaginationMeta => state.paginationMeta,
  exposedPaginationMeta: (state: IFundState): PaginationMeta =>
    state.exposedPaginationMeta,
  organizationSubFunds: (state: IFundState): SubFund[] =>
    state.organizationSubFunds,
  organizationManagers: (state: IFundState): OrganisationManager[] =>
    state.organizationManagers,
  exposedFundsFilters: (state: IFundState): FundFilters | null =>
    state.exposedFundsFilters,
  allFundsFilters: (state: IFundState): FundFilters | null =>
    state.allFundsFilters
};

/**
 * --------------------------------------------------
 *	Organisation Getters Interface
 * --------------------------------------------------
 **/
export interface IFundGetters extends GetterTree<IFundState, IRootState> {
  organizationFunds(state: IFundState): Fund[];
  selectedFund(state: IFundState): FundRow;
  organizationExposedFunds(state: IFundState): Fund[];
  organizationPensionSchemes(state: IFundState): PensionScheme[];
  strategies(state: IFundState): Strategy[];
  productTypes(state: IFundState): ProductType[];
  paginationMeta(state: IFundState): PaginationMeta;
  exposedPaginationMeta(state: IFundState): PaginationMeta;
  organizationSubFunds(state: IFundState): SubFund[];
  organizationManagers(state: IFundState): OrganisationManager[];
  exposedFundsFilters(state: IFundState): FundFilters | null;
  allFundsFilters(state: IFundState): FundFilters | null;
}
